import React from 'react';

interface CheckboxProps {
  label?: string;

  checked: boolean;

  onChange: () => void;

  disabled?: boolean;

  id?: string;

  className?: string;
}

const Checkbox: React.FC<CheckboxProps> = ({
  label,
  checked,
  onChange,
  disabled = false,
  id,
  className = '',
}) => {
  return (
    <label
      className={`
        flex
        items-center
        gap-2
        text-sm
        font-medium
        text-black
        dark:text-white
        ${disabled ? 'cursor-not-allowed opacity-70' : 'cursor-pointer'}
        ${className}
      `}
    >
      <div className="relative shrink-0">
        <input
          type="checkbox"
          id={id}
          className="sr-only"
          checked={checked}
          disabled={disabled}
          onChange={onChange}
        />

        <div
          className={`
            flex
            h-5
            w-5
            items-center
            justify-center
            rounded-md
            border
            transition-all
            duration-200
            ${
              checked
                ? 'border-primary bg-primary/10 ring-2 ring-primary/10'
                : `
              border-stroke
              bg-gray-2
              hover:border-primary/40
              hover:bg-primary/5
              dark:border-strokedark
              dark:bg-meta-4
            `
            }
          `}
        >
          <span
            className={`
              h-2.5
              w-2.5
              rounded-sm
              transition-all
              duration-200
              ${checked ? 'bg-primary' : 'bg-transparent'}
            `}
          />
        </div>
      </div>

      {label && <span className="block">{label}</span>}
    </label>
  );
};

export default Checkbox;
